export enum UserType {
  Unknown = '',
  State = 'State',
  District = 'District',
}
